import request from '@/utils/service'

// 反馈
export function listApi(data) {
  return request({
    url: '/demandReport/list',
    method: 'get',
    params: data
  })
}

export function auditApi(data) {
  return request({
    url: '/walletWithdraw/audit',
    method: 'post',
    data
  })
}

// 用户反馈
export function userFeedback(data) {
  return request({
    url: '/fault/report/list',
    method: 'get',
    params: data
  })
}
